export function questionMaper(value) {

    if (!value) return null
    const { isMandatory, questionKey } = value.questionConfig;
    const { title, additionalText: additionalDescription, hintText, buttonClear, helperText, warningText, label, buttonSubmit } = value.question;
    const questionConfig = value.questionConfig
    const answersConfig = value.answersConfig
    const executeAfterProxyQuestion = value.executeAfterProxyQuestion
    const executeAfterInternalQuestion = value.executeAfterInternalQuestion
    const executeAfterProxyAnswer = value.executeAfterProxyAnswer
    const executeAfterInternalAnswer = value.executeAfterInternalAnswer
    const answers = answersConfig && value.answers.map((answer, index) => {
        const { answerKey, order } = value.answersConfig[index];
        const { title, additionalText } = answer;
        return { answerKey, title, additionalDescription: additionalText, order, hintText }
    })

    return {
        questionKey,
        isMandatory,
        title,
        additionalDescription,
        answers,
        buttonSubmit,
        hintText,
        buttonClear,
        questionConfig,
        answersConfig,
        helperText,
        warningText,
        label,
        executeAfterProxyQuestion,
        executeAfterInternalQuestion,
        executeAfterProxyAnswer,
        executeAfterInternalAnswer,
    }
}